import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ChatAdminService } from '../../services/chat-admin.service';
import { MessageEx } from '../../classes/messageex';
import { ContentTypes } from '../../classes/constants';
import { LocationService } from '../../services/location.service';
import { Subject } from 'rxjs';
import { IChatMessageInfo } from '../../interfaces/chat-info-interfaces';
import { ChatConfig } from '../chat/chat.component';

@Component({
  selector: 'lib-chat-message-info',
  templateUrl: './message-info.component.html',
  styleUrls: ['./message-info.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageInfoComponent implements OnInit {
  public contentTypes = ContentTypes;
  private ngUnsubscribe: Subject<void> = new Subject();

  // Internal signal state - all properties set from dialogConfig.data
  title = signal<string>('');
  item = signal<MessageEx | undefined>(undefined);
  maxImageSize = signal<number | undefined>(undefined);
  dateTimeLocale = signal<string | undefined>(undefined);
  isReadByAll = signal<boolean>(false);
  readList = signal<Array<IChatMessageInfo>>([]);
  deliveredList = signal<Array<IChatMessageInfo>>([]);
  isMine = signal<boolean>(false);
  config = signal<ChatConfig | undefined>(undefined);

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    public chatAdminService: ChatAdminService,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    // Get data from dialog config
    if (this.dialogConfig.data) {
      this.title.set(this.dialogConfig.data.title);
      this.item.set(this.dialogConfig.data.item);
      this.maxImageSize.set(this.dialogConfig.data.maxImageSize);
      this.dateTimeLocale.set(this.dialogConfig.data.dateTimeLocale);
      this.isReadByAll.set(this.dialogConfig.data.isReadByAll);
      this.readList.set(this.dialogConfig.data.readList);
      this.deliveredList.set(this.dialogConfig.data.deliveredList);
      this.isMine.set(this.dialogConfig.data.isMine);
      this.config.set(this.dialogConfig.data.config);
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cancelClick() {
    this.dialogRef.close();
  }
}
